import React from 'react';
import { Box } from '@mui/material';
import LicenseRequestList from '../components/LicenseRequestList';
import { PageHeader } from '../components/ui';

const LicenseRequestPage: React.FC = () => (
  <Box>
    <PageHeader
      eyebrow="Licensing"
      title="Bulk activation"
      description="Activate or extend licences for many serial numbers at once."
    />
    <LicenseRequestList />
  </Box>
);

export default LicenseRequestPage;
